import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    const phoneNumber = '33749995728'; // Format international sans le +
    const message = encodeURIComponent('Bonjour, je souhaite obtenir un devis pour une reprogrammation moteur. Pouvez-vous me contacter ?');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Desktop - bottom left */}
      <div className="hidden md:block fixed bottom-8 left-8 z-50">
        <button
          onClick={handleWhatsAppClick}
          className="group relative flex items-center bg-[#25D366] hover:bg-[#20BA5A] text-white px-6 py-4 rounded-full shadow-2xl hover:shadow-[#25D366]/50 transition-all transform hover:scale-110"
          style={{
            animation: 'slideInLeft 0.5s ease-out'
          }}
        >
          <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-75"></div>
          <MessageCircle className="h-6 w-6 mr-3 relative z-10" />
          <span className="font-bold text-lg relative z-10">WhatsApp</span>
        </button>
      </div>

      {/* Mobile - bottom left */}
      <div className="md:hidden fixed bottom-20 left-6 z-50">
        <button
          onClick={handleWhatsAppClick}
          className="relative flex items-center justify-center bg-[#25D366] text-white w-16 h-16 rounded-full shadow-2xl"
          style={{
            animation: 'slideInLeft 0.5s ease-out'
          }}
        >
          <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-75"></div>
          <MessageCircle className="h-7 w-7 relative z-10" />
        </button>
      </div>

      <style jsx>{`
        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-100px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
      `}</style>
    </>
  );
};

export default WhatsAppButton;
